import { render } from "./AIAgentSettings.vue?vue&type=template&id=51f4e646&scoped=true"
import script from "./AIAgentSettings.vue?vue&type=script&lang=js"
export * from "./AIAgentSettings.vue?vue&type=script&lang=js"

import "./AIAgentSettings.vue?vue&type=style&index=0&id=51f4e646&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f4e646"]])

export default __exports__